import Vue, { VueConstructor } from 'vue';
import _ from 'lodash';
import { gameStore } from '@/store/game/store';
import { JustoneClient } from '@/client';
import { Action } from '@/actions';
import CurrentPlayer from "./CurrentPlayer.vue";
import Hints from "./Hints.vue";

export default (Vue as VueConstructor<Vue & {
    $refs: {
        gameLink: HTMLInputElement
    };
}>).extend({
    data() {
        return {
            showTooltip1: false
        };
    },
    computed: {
        joined(): boolean {
            return !!gameStore.state.gid;
        },
        gameLink(): string {
            return window.location.href.split('?')[0] + "?gid=" + gameStore.state.gid;
        },
        isOwner() {
            return gameStore.state.isOwner;
        },
        gameStarted() {
            return gameStore.state.currentTurn.turn > -1;
        },
        turn() {
            return gameStore.state.currentTurn.turn;
        },
        isCurrentPlayer(){
            return gameStore.state.playerInfo.id == gameStore.state.currentTurn.currentPlayerId;
        },
        currentPlayer() {
            return _.find(gameStore.state.players, p => p.id == gameStore.state.currentTurn.currentPlayerId);
        },
        players() {
            return gameStore.state.players;
        },
        word() {
            return gameStore.state.currentTurn.word;
        }
    },
    methods: {
        copyLink(input: HTMLInputElement) {
            input.select();
            input.setSelectionRange(0, 99999);
            /*For mobile devices*/
            document.execCommand("copy");
            if (input.name == "game") this.showTooltip1 = true;
            this.$nextTick(() => {
                this.showTooltip1 = false;
            });
        },
        newGame() {
            window.location.href = window.location.href.split('?')[0];
        },
        start() {
            JustoneClient.getInstance().send({
                action: Action.start
            })
        },
    },
    components: {
        CurrentPlayer,
        Hints
    }
})